import {
  collection,
  doc,
  type CollectionReference,
  type DocumentData,
  type DocumentReference,
  type Firestore,
  type FirestoreDataConverter,
  type QueryDocumentSnapshot,
} from 'firebase/firestore';

/** Stores everything except `id`; reads `id` from the document id. */
export function withId<T extends { id: string }>(): FirestoreDataConverter<T> {
  return {
    toFirestore(value) {
      const { id: _id, ...rest } = value as T;
      return rest as DocumentData;
    },
    fromFirestore(snap: QueryDocumentSnapshot) {
      return { id: snap.id, ...snap.data() } as T;
    },
  };
}

export function typedCollection<T extends { id: string }>(db: Firestore, path: string): CollectionReference<T> {
  return collection(db, path).withConverter(withId<T>());
}

export function typedDoc<T extends { id: string }>(db: Firestore, path: string): DocumentReference<T> {
  return doc(db, path).withConverter(withId<T>());
}
